var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path10, _circle2, _path11, _path12, _circle3, _path13, _path14, _rect, _path15, _path16, _rect2, _path17, _path18, _rect3, _path19, _path20, _rect4, _path21, _path22, _rect5, _path23, _path24, _path25, _polygon, _path26, _polygon2, _path27, _path28, _path29, _path30, _path31, _circle4, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 751.13137,
    height: 526.91128,
    viewBox: "0 0 751.13137 526.91128",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M803.9793,711.53349l.01521-.697a80.52863,80.52863,0,0,1,30.11215-60.64309A78.1326,78.1326,0,0,1,850.89289,640.078l.572-.25474.09758.61813c1.16152,7.38021,3.0009,14.91289,3.85784,18.25612l5.74415-22.41411.63823-.18436a15.27246,15.27246,0,0,1,16.303,5.20878,15.53409,15.53409,0,0,1,1.61173,17.33177c-1.33891,2.49455-2.655,5.09733-3.9282,7.61426-4.37385,8.64929-8.89655,17.59309-15.48708,24.54163A48.6753,48.6753,0,0,1,821.043,705.4408Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M629.34213,506.85309H481.06067A20.13792,20.13792,0,0,1,460.94553,486.738V278.13886a91.956,91.956,0,0,1,91.85189-91.85223h76.54505a20.13755,20.13755,0,0,1,20.1148,20.1148V486.738A20.1377,20.1377,0,0,1,629.34213,506.85309Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M486.24565,367.57055a8.4817,8.4817,0,0,0-8.472,8.472v47.61288a8.482,8.482,0,0,0,8.472,8.47232H630.34756a8.482,8.482,0,0,0,8.472-8.47232V376.04253a8.4817,8.4817,0,0,0-8.472-8.472Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M630.6943,336.68029H486.59273a9.17633,9.17633,0,0,1-9.16614-9.16614A56.84375,56.84375,0,0,1,534.206,270.73479h96.48868a9.17632,9.17632,0,0,1,9.16614,9.16614v47.61288A9.17691,9.17691,0,0,1,630.6943,336.68029Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M692.73619,424.823H526.852a3.68184,3.68184,0,0,1-3.67764-3.67763V377.43719a3.68172,3.68172,0,0,1,3.67764-3.6775H692.73619a3.68172,3.68172,0,0,1,3.67763,3.6775v43.70819A3.68184,3.68184,0,0,1,692.73619,424.823Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M692.73635,425.51721H526.852a4.37667,4.37667,0,0,1-4.37173-4.37173V377.43726a4.37668,4.37668,0,0,1,4.37173-4.37174H692.73635a4.37669,4.37669,0,0,1,4.37174,4.37174v43.70822A4.37668,4.37668,0,0,1,692.73635,425.51721ZM526.852,374.45385a2.987,2.987,0,0,0-2.98341,2.98341v43.70822a2.987,2.987,0,0,0,2.98341,2.98341H692.73635a2.987,2.987,0,0,0,2.98341-2.98341V377.43726a2.987,2.987,0,0,0-2.98341-2.98341Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 316.86351,
    cy: 202.22276,
    r: 5.96774,
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M682.82044,403.54773H536.767a1.77708,1.77708,0,1,1,0-3.55415h146.0534a1.77708,1.77708,0,1,1,0,3.55415Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M668.30823,410.56982H536.767a1.77716,1.77716,0,1,1,0-3.55432H668.30823a1.77716,1.77716,0,0,1,0,3.55432Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M520.40082,709.89731,479.799,693.714a3.68173,3.68173,0,0,1-2.05446-4.77789l61.42016-154.09458a3.68173,3.68173,0,0,1,4.77781-2.05464l40.60179,16.18336a3.68185,3.68185,0,0,1,2.05458,4.77794L525.17876,707.84273A3.68184,3.68184,0,0,1,520.40082,709.89731Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M520.14386,710.54227,479.54205,694.3589a4.37667,4.37667,0,0,1-2.44235-5.67971l61.42019-154.09467a4.37668,4.37668,0,0,1,5.67971-2.44236l40.6018,16.18337a4.37668,4.37668,0,0,1,2.44236,5.67971l-61.4202,154.09467A4.37668,4.37668,0,0,1,520.14386,710.54227Zm-41.75451-21.349a2.987,2.987,0,0,0,1.66674,3.876l40.60181,16.18337a2.987,2.987,0,0,0,3.876-1.66674L585.9541,553.49119a2.987,2.987,0,0,0-1.66674-3.876l-40.6018-16.18336a2.987,2.987,0,0,0-3.876,1.66674Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#ccc"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 323.5493,
    cy: 367.11921,
    r: 5.96774,
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M506.77807,691.74719a1.77908,1.77908,0,0,1-.99268-2.3088L559.863,553.76522a1.77707,1.77707,0,1,1,3.30154,1.316L509.08694,690.75434A1.77922,1.77922,0,0,1,506.77807,691.74719Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M518.67438,680.86638a1.77922,1.77922,0,0,1-.99285-2.30887l48.70434-122.19236a1.77716,1.77716,0,1,1,3.30171,1.316L520.98324,679.87353A1.77921,1.77921,0,0,1,518.67438,680.86638Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.23991,
    cy: 25.52901,
    r: 15.70886,
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M628.06868,211.19448h-7.0662v-7.06615a.66847.66847,0,1,0-1.33693,0v7.06615H612.5994a.66847.66847,0,1,0,0,1.33694h7.06615v7.06632a.66847.66847,0,1,0,1.33693,0v-7.06632h7.0662a.66847.66847,0,0,0,0-1.33694Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M813.91251,224.75907h-53a13,13,0,0,1,0-26h53a13,13,0,0,1,0,26Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#000000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 683.01629,
    y: 156.93048,
    width: 2.00021,
    height: 102.42963,
    transform: "translate(241.91877 702.79726) rotate(-89.17239)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M628.52225,212.83085a5.00884,5.00884,0,1,1,2.187-.5083A5.0049,5.0049,0,0,1,628.52225,212.83085Zm-.00683-8.0044a3.0023,3.0023,0,1,0,2.69873,1.687V206.513a3.00742,3.00742,0,0,0-2.69873-1.68653Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M321.68646,241.75907a13.01442,13.01442,0,0,1,13-13h53a13,13,0,0,1,0,26h-53A13.01442,13.01442,0,0,1,321.68646,241.75907Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#000000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 413.36776,
    y: 237.14519,
    width: 102.42963,
    height: 2.00021,
    transform: "matrix(0.9999, -0.01444, 0.01444, 0.9999, -227.48541, -179.55136)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M517.8897,242.32255a4.96712,4.96712,0,1,1,2.187.5083A4.96832,4.96832,0,0,1,517.8897,242.32255Zm1.21436-7.33106a2.97974,2.97974,0,0,0-1.71924,1.52149v.00048a3.0069,3.0069,0,1,0,1.71924-1.522Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M317.68646,634.75907a13.01442,13.01442,0,0,1,13-13h53a13,13,0,0,1,0,26h-53A13.01442,13.01442,0,0,1,317.68646,634.75907Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#000000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 409.36776,
    y: 630.14519,
    width: 102.42963,
    height: 2.00021,
    transform: "matrix(0.9999, -0.01444, 0.01444, 0.9999, -233.16232, -179.56814)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M513.8897,635.32255a4.96712,4.96712,0,1,1,2.187.5083A4.96832,4.96832,0,0,1,513.8897,635.32255Zm1.21436-7.33106a2.97974,2.97974,0,0,0-1.71924,1.52149v.00048a3.0069,3.0069,0,1,0,1.71924-1.522Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M331.68646,386.75907a13.01442,13.01442,0,0,1,13-13h53a13,13,0,0,1,0,26h-53A13.01442,13.01442,0,0,1,331.68646,386.75907Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#000000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 423.36776,
    y: 382.14519,
    width: 102.42963,
    height: 2.00021,
    transform: "matrix(0.9999, -0.01444, 0.01444, 0.9999, -229.57875, -179.39179)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M527.8897,387.32255a4.96712,4.96712,0,1,1,2.187.5083A4.96832,4.96832,0,0,1,527.8897,387.32255Zm1.21436-7.33106a2.97974,2.97974,0,0,0-1.71924,1.52149v.00048a3.0069,3.0069,0,1,0,1.71924-1.522Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M799.91251,307.75907h-53a13,13,0,0,1,0-26h53a13,13,0,0,1,0,26Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#000000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 669.01629,
    y: 239.93048,
    width: 2.00021,
    height: 102.42963,
    transform: "translate(145.12965 770.59987) rotate(-89.17239)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M614.52225,295.83085a5.00884,5.00884,0,1,1,2.187-.5083A5.0049,5.0049,0,0,1,614.52225,295.83085Zm-.00683-8.0044a3.0023,3.0023,0,1,0,2.69873,1.687V289.513a3.00742,3.00742,0,0,0-2.69873-1.68653Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M828.25679,455.83514l-15.39383.68255c-3.46912,9.43338-1.01156,32.33509-1.01156,32.33509l-8.08722,37.63365a6.803,6.803,0,1,0,11.36926,3.0536l16.42392-45.12743Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#9e616a"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M818.016,414.674l0,0a16.25748,16.25748,0,0,1,16.60376,18.71994l-1.47888,9.61585s4.22941,32.73431-.92725,41.64329l-9.835,26.63239-16.04618-.82057,4.43659-29.08315s1.11925-14.39459-2.97566-20.484c-2.5078-3.72927-5.05686-17.76353-5.493-29.48921A16.21584,16.21584,0,0,1,818.016,414.674Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "582.798 514.593 572.803 514.592 568.047 476.036 582.801 476.036 582.798 514.593",
    fill: "#9e616a"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M807.24471,711.30692l-30.73877-.00116V710.917a11.965,11.965,0,0,1,11.96438-11.9642h.00074l5.61483-4.2597,10.476,4.26035,2.68329.00009Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "546.681 514.593 536.686 514.592 531.93 476.036 546.684 476.036 546.681 514.593",
    fill: "#9e616a"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M771.12766,711.30692l-30.73878-.00116V710.917a11.965,11.965,0,0,1,11.96439-11.9642h.00074l5.61483-4.2597,10.476,4.26035,2.6833.00009Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M734.47912,595.80822c5.93641,18.91131,8.21561,33.748,12.73983,52.47355,1.7866,3.28753,9.47745,30.6042,9.47745,30.6042s11.52641,1.26474,15.60334-1.96128-.12416-19.191-.12416-19.191c2.68764-12.07034-3.9368-31.08787-4.32929-42.7896.81542-4.911-3.507-9.12684-3.90273-13.81047,2.85733-2.1745,16.7583-36.29707,19.59306-45.83179-1.4568,29.05308,11.32377,95.38947,4.59008,117.427-3.91226,12.80377,5.18165,9.95754,18.64841,10.57672,6.00452-1.78355,3.562-12.06163,3.562-12.06163s4.07693-6.7888,4.07693-9.42105c2.91885-12.318,6.42707-39.113,5.46967-45.13435.43874-6.39149.65558-70.24643,5.53743-92.61259,3.25338-17.81658-36.61842-21.73853-48.08519-25.98709-19.134-9.2184-15.9047,3.88731-25.9812,15.96036C741.63864,534.86067,735.91567,572.02368,734.47912,595.80822Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#2f2e41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M779.14515,408.51184l11.624-13.08854,18.3673,2.04081,11.75932,16.457h0c12.9965,2.9911,15.3931,13.6171,13.11122,26.75668-4.56331,26.27663-15.82819,44.64392-10.70752,57.60889,7.77305,19.6805,4.00424,34.825-14.60248,32.0658s-61.48312-20.9802-49.39752-33.0658,1.28031-18.42093,1.28031-18.42093l8.48464-46.20391c-2.17285-11.78328-1.83758-22.91649,10.0807-24.14995Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M780.63832,449.9913l-14.64925-4.77865c-6.56707,7.609-12.32651,29.9105-12.32651,29.9105l-20.81423,32.38a6.803,6.803,0,1,0,9.56728,6.85943l31.25488-36.46042Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#9e616a"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M785.53852,407.85936l0,0a16.25747,16.25747,0,0,1,8.95347,23.36571l-4.76837,8.48022s-7.56132,32.12864-15.52342,38.6529l-18.57854,21.4674-14.73087-6.41518,14.388-25.66124s6.11353-13.07982,4.42363-20.22077c-1.03494-4.37327,1.51814-18.4068,5.23654-29.53583A16.21584,16.21584,0,0,1,785.53852,407.85936Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "fe5d9414-b808-43bb-a4dc-97fa5cac342b",
    "data-name": "ab6171fa-7d69-4734-b81c-8dff60f9761b",
    cx: 580.31835,
    cy: 187.36004,
    r: 18.98646,
    fill: "#a0616a"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M787.88253,356.56263a10.68547,10.68547,0,0,1,1.85848-4.36893,5.2247,5.2247,0,0,1,7.78416-.23659,5.72936,5.72936,0,0,1-.252-2.68761,14.55772,14.55772,0,0,0,4.39469,1.30711l-3.36915-3.51783c6.92175-3.07562,12.64111-2.90948,16.77112,1.5409,1.18237,1.27414,3.60278.38425,4.87379,1.69922,1.27107,1.31491,1.34158,4.1216-.26495,4.85481,3.16571-1.19215,6.80092.53826,8.88943,3.43749,2.08857,2.89918,2.85765,6.72346,2.99877,10.43341.18292,4.81081-.71367,9.9325-3.65012,13.47433-1.92017,2.31606-4.53847,3.76034-6.66353,5.844l-.06361.06282a18.89076,18.89076,0,0,1-18.28587,5.09389c-.36234-.09959-.72214-.21015-1.08369-.31324-1.80735.81744-4.05828-.30015-5.19908-2.11767-1.21655-1.93813-1.45682-4.418-1.50834-6.78012a55.58331,55.58331,0,0,1,.569-9.23623c.503-3.44314.95636-7.85263-1.77057-9.58208-2.123-1.34643-4.76087-.01774-6.89814,1.30062A35.49735,35.49735,0,0,1,787.88253,356.56263Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#2f2e41"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M974.03479,712.89058l-748.75.30733a1.19069,1.19069,0,0,1,0-2.38137l748.75-.30733a1.19068,1.19068,0,1,1,0,2.38137Z",
    transform: "translate(-224.09411 -186.28663)",
    fill: "#cacaca"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.58542eedf2df966a034180e9fc62e969.svg";
export { ForwardRef as ReactComponent };